import { useSelector } from "react-redux";
import { Alert, Button, TextField, Typography } from "@mui/material";
import { useRefundStatus } from "../hooks/use-refund-status";

export default function SandboxRefundStatus() {
  const token = useSelector((state) => state.user.token);
  const status = useRefundStatus(token);
  return <section className="mt-6">
    <Typography variant="h6">پیگیری بازپرداخت قبلی</Typography>
    <Typography className="my-3">شناسهٔ عملیات قبلی را وارد کنید؛ این بخش فقط وضعیت را از درگاه استعلام می‌کند.</Typography>
    <TextField fullWidth label="شناسه عملیات بازپرداخت قبلی" value={status.id} disabled={status.busy}
      onChange={(event) => status.setId(event.target.value)} inputProps={{ dir: "ltr" }} />
    <Button className="my-3" disabled={status.busy || !status.id.trim()} onClick={status.refresh}>استعلام عملیات قبلی</Button>
    {status.error && <Alert severity="error">{status.error}</Alert>}
    {status.result && <Alert severity="info">عملیات: <span dir="ltr">{status.result.id}</span> — وضعیت: {status.result.status}</Alert>}
  </section>;
}
